export default "<mat-form-field>\n  <input (ngModelChange)=\"changeValue($event)\" [ngModel]=\"rule.value\" matInput type=\"number\">\n</mat-form-field>\n";